module.exports = __webpack_public_path__ + "img/8.3.TP.8089687a.png";